import { Controller } from "@hotwired/stimulus"

export default class SignOutController extends Controller {
  signOut(event) {
    if (this._isTurboNativeApp) {
      event.preventDefault()
      event.stopImmediatePropagation()
      globalThis.TurboNativeBridge?.postMessage("signOut")
    }
  }

  get _isTurboNativeApp() {
    return navigator.userAgent.includes("Turbo Native")
  }
}
